// Custom Tattooed Abroad flame alphabet initial — a decorative opening letter
// for major editorial headlines. Remaining headline text stays in its typeface.
const AVAILABLE = ["b", "c", "e", "f", "h", "j", "o", "t", "v", "s"];

export const FlameInitial = ({ letter, size = "0.81em", className = "" }) => {
  const key = String(letter).toLowerCase();
  if (!AVAILABLE.includes(key)) return letter;
  return (
    <img
      src={`/brand/ta-letter-${key}.png`}
      alt={letter}
      data-testid={`flame-initial-${key}`}
      className={`inline w-auto select-none ${className}`}
      style={{ height: size, verticalAlign: "baseline" }}
    />
  );
};
